import { createAction } from '@reduxjs/toolkit';

export const requestCreateMember = createAction('request/createMember');
export const requestViewAllMembers = createAction('request/viewAllMembers');
export const requestUpdateMember = createAction('request/updateMember');
export const requestDeleteMember = createAction('request/deleteMember');
export const requestDownloadMemberExcel = createAction('request/downloadMemberExcel');
export const requestViewTribeMembers = createAction('request/viewTribeMembers');
export const requestViewMember = createAction('request/viewMember');
export const requestViewMemberProfile = createAction('request/viewMemberProfile');
